import { getInstance } from '@/auth/auth0-plugin'

export const READ_ONLY_ROLE = 'jbg-read-only'
const ADMIN_ROLES = ['promo.admin', 'pce-admin', 'jbg-admin']

export const isReadOnlyUser = (auth) => {
  const groups = auth?.userGroups || []
  return groups.includes(READ_ONLY_ROLE) && !ADMIN_ROLES.some(role => groups.includes(role))
}

const TOOLKIT_HEADER = 'Looks like this action is not a part of your toolkit—yet'
const TOOLKIT_DETAIL = 'Check with your admin or reach out to JBG Support at jbg.support@jbgottstein.com if you think you should have access.'

// The interceptors attach at module load, before the Vue app exists, so App.vue
// hands us its $root once created — that's where AlertBar listens for 'alertdialog'.
// No store import here: store/index.js sits on this module's import cycle.
let alertRoot = null
export const registerAlertRoot = (vm) => { alertRoot = vm }

// Surfaces the friendly toolkit message when a view-only (jbg-read-only) user's
// write attempt is rejected by the API. All other errors pass through untouched.
export const attachReadOnlyInterceptor = (api) => {
  api.interceptors.response.use(
    response => response,
    error => {
      if (error?.response?.status === 403 && isReadOnlyUser(getInstance()) && alertRoot) {
        alertRoot.$emit('alertdialog', {
          alert: true,
          alertType: 'warning',
          alertMessage: TOOLKIT_HEADER,
          messages: [TOOLKIT_DETAIL]
        })
      }
      return Promise.reject(error)
    }
  )
  return api
}
